import { getRuntimeConfig } from './runtime-config';

/** True on a developer's dev server, which serves its own config.js; no build defines a local NODE_ENV. */
export const IS_LOCAL = getRuntimeConfig().env === 'local';
/** True for unit tests, but not for e2e tests. */
export const IS_JEST_TEST = process.env.NODE_ENV === 'test';
export const IS_HOSTED = process.env.NODE_ENV === 'production';
export const IS_STAGING = getRuntimeConfig().env === 'staging';
export const IS_PROD = getRuntimeConfig().env === 'production';
